import React, { useState } from 'react';
import VideoInfoModuleMobile from 'components/templates/videoInfoModuleMobile';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import './styles.scss';

const MachineCraftMobile = props => {
  const { height } = useViewport();
  const { data } = props.data;
  const { breadcrumbList } = props;
  const [showDescriptionLayout, setShowDescriptionLayout] = useState(false);
  const { machineCraftSection, testingForWorkspaces, type = 'homes' } = data;
  let machineCraftOverlay = data && data.machineCraftOverlay;

  const checkButton = () => {
    if (
      (type === 'workcations' && testingForWorkspaces) ||
      (type === 'homes' && machineCraftOverlay)
    ) {
      return 'EXPLORE';
    }

    return false;
  };

  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={
          type === 'workcations' ? testingForWorkspaces : machineCraftOverlay
        }
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'machineCraft'}
        onClosePress={() => setShowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'machine-craft-mobile'} style={{ height }}>
      <VideoInfoModuleMobile
        buttonName={checkButton()}
        heading={machineCraftSection.heading}
        subHeading={machineCraftSection.sub_heading_mobile}
        content={machineCraftSection.paragraph_mobile}
        videoData={machineCraftSection.video}
        videoThumbnailUrl={machineCraftSection.video_thumbnail_url}
        onClick={e => setShowDescriptionLayout(true)}
      />
      {showOverlay}
    </div>
  );
};

export default MachineCraftMobile;
